import { Outlet } from "@tanstack/react-router";

import { Footer } from "@/components/footer";
import Header from "@/components/header";

export function LegalLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header showSearch={false} />
      <main className="flex-1 px-4 py-12">
        <article className="prose prose-invert mx-auto max-w-3xl">
          <Outlet />
        </article>
      </main>
      <Footer />
    </div>
  );
}
